import { useEffect, useRef, type ReactNode } from "react";

/** Shared by the conversation rail and entity detail; native modal focus/escape semantics. */
export function WorkspaceSidePanel({ children, className, drawer, open, onClose, label, id, triggerId, side = "right" }: {
  children: ReactNode;
  className: string;
  drawer: boolean;
  open: boolean;
  onClose: () => void;
  label: string;
  id: string;
  triggerId: string;
  side?: "left" | "right";
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current!;
    if (open) {
      if (drawer) dialog.showModal();
      else dialog.setAttribute("open", "");
    }
    return () => {
      if (dialog.open) dialog.close();
      if (drawer && open) document.getElementById(triggerId)?.focus();
    };
  }, [drawer, open, triggerId]);

  return <dialog
    ref={ref}
    id={id}
    className={`workspace-side-panel ${className} ${drawer ? "is-drawer" : "is-inline"} drawer-${side}`}
    aria-label={label}
    role={drawer ? "dialog" : "complementary"}
    aria-modal={drawer && open ? true : undefined}
    onCancel={(event) => { event.preventDefault(); onClose(); }}
    onKeyDown={(event) => { if (drawer && event.key === "Escape") event.stopPropagation(); }}
  >{children}</dialog>;
}
